/*=========================================================================================
  File Name: router.js
  Description: Routes for vue-router. Lazy loading is enabled.
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

import Vue from "vue";
import Router from "vue-router";
import Error404 from "@/views/pages/Error404.vue";
import FullPage from "@/layouts/full-page/FullPage.vue";
import FormWizardRegister from "@/views/forms/form-wizard/FormWizardRegister.vue";
import SuccessRegister from "@/views/pages/SuccessRegister.vue";
import ErrorRegister from "@/views/pages/ErrorRegister.vue";

Vue.use(Router);

const router = new Router({
  mode: "history",
  base: process.env.BASE_URL,
  scrollBehavior() {
    return { x: 0, y: 0 };
  },
  routes: [
    {
      path: "",
      component: FullPage,
      children: [
        // =============================================================================
        // PAGES
        // =============================================================================

        {
          path: "/error-404",
          name: "page-error-404",
          component: Error404,
        },
        {
          path: "/",
          name: "register",
          component: FormWizardRegister,
        },
        {
          path: "/pre-sale/:numeroSede",
          name: "pre-sale-register",
          component: FormWizardRegister,
          props: (route) => ({
            preSaleMode: true,
            preSaleLocationNumber: route.params.numeroSede,
          }),
          beforeEnter: (to, from, next) => {
            const { numeroSede } = to.params;
            const isValidLocationNumber = /^\d+$/.test(
              String(numeroSede || "")
            );

            if (!isValidLocationNumber) {
              next({
                name: "error",
                query: {
                  MESSAGE: btoa(
                    "El enlace de preventa no es válido. Verifique el número de sede e intente nuevamente."
                  ),
                },
              });
              return;
            }

            next();
          },
        },
        {
          path: "/success",
          name: "success",
          component: SuccessRegister,
        },
        {
          path: "/error",
          name: "error",
          component: ErrorRegister,
        },
      ],
    },
    // Redirect to 404 page, if no match found
    {
      path: "*",
      redirect: "/error-404",
    },
  ],
});

router.afterEach(() => {
  // Remove initial loading
  const appLoading = document.getElementById("loading-bg");
  if (appLoading) {
    appLoading.style.display = "none";
  }
});

export default router;
